<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex align-items-start justify-content-between">
        <div>
          <h1 class="page-title">{{$t('Other.ressources')}}</h1>
          <h2 class="page-subtitle">{{ totalCount }} {{ totalCount === 1 ? $t('resource') : $t('resources')}}</h2>
        </div>
        <b-button variant="primary" @click="clickOnCreateBtn" v-if="allowCreate">
          {{$t('Add2')}} {{$t('a.e')}} {{$t('resource')}}
        </b-button>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">

        <b122-table
          ref="B122TableResource"
          identifier="B122TableResource"
          get-b122-table-results-url="/resource/getB122TableResults?restrictbyboolean-robustagnoVideo=False"
          :fields="tableFields"
          :editItem=allowEdit
          :deleteItem=allowDelete
          :empty-title="$t('resource.emptyTitle').toString()"
          :empty-text="$t('resource.emptyText').toString()"
          @setTotalCount="setTotalCount"
          @clickOnShowBtn="clickOnShowBtn"
          @clickOnEditBtn="clickOnEditBtn"
          @clickOnDeleteBtn="clickOnDeleteBtn">

<!--          <template #cell(technician)="data">-->
<!--            <div class="textual-link" @click="goToTechnician(data.item.technician.id )">{{ data.item.technician.tostring }}</div>-->
<!--          </template>-->
          <template #cell(resourceType)="data">
            <div>{{resourceTrad(data.item.resourceType) }}</div>
          </template>
          <template #cell(actions)="data">
            <div class="actions-container text-right" >
              <button class="action-btn edit mr-1" @click="clickOnEditBtn(data)" v-if="allowEdit">
                <i class="ph-custom ph-pencil-simple-line-fill"/>
              </button>
              <button class="action-btn delete" @click="clickOnDeleteBtn(data)" v-if="allowDelete&&!(data.item.nbSheetLinked&&data.item.nbSheetLinked>0)">
                <i class="ph-custom ph-trash-fill"/>
              </button>
            </div>
          </template>
        </b122-table>
      </b-card>
    </b-container>

    <Item-delete-modal
      :beginsWithVoyel="false"
      :isFeminine="true"
      :selectedItem="selectedItem"
      controllerName="resource"
      itemSingularName="resource"
      itemSingularNameUpp="Resource"
      @didDeleteItem="didDeleteItem()">
    </Item-delete-modal>

  </div>
</template>

<script>

import B122Table from '../../components/b122/B122Table'
import ItemDeleteModal from '../../components/b122/ItemDeleteModal'
export default {

  name: 'ResourceIndex',

  components: {
    B122Table,
    ItemDeleteModal
  },

  data () {
    let isAuthorized = this.$store.getters.isSuperAdmin || this.$store.getters.isAdmin
    return {

      totalCount: 0,
      allowCreate: isAuthorized,
      allowDelete: isAuthorized,
      allowEdit: isAuthorized,
      selectedItem: null
    }
  },

  computed: {

    tableFields () {
      return [
        {
          label: '',
          key: 'show',
          sortable: false
        },
        {
          label: this.$i18n.t('Resource.title'),
          key: 'title',
          sortable: true
        },
        {
          label: this.$i18n.t('Resource.ResourceType'),
          key: 'resourceType',
          sortable: true
        },
        {
          label: this.$i18n.t('Resource.sheets.linked'),
          key: 'sheetsLinked',
          sortable: false
        },
        {
          label: '',
          key: 'actions'
        }
      ]
    }

  },

  methods: {

    resourceTrad (value) {
      return this.$i18n.t(value)
    },

    setTotalCount (totalCount) {
      this.totalCount = totalCount
    },

    clickOnCreateBtn () {
      this.$router.push({
        name: 'ResourceCreate'
      })
    },

    clickOnShowBtn (row) {
      this.$router.push({
        name: 'ResourceShow',
        params: {
          resourceId: row.item.id
        }
      })
    },

    goToTechnician (id) {
      this.$router.push({
        name: 'TechnicianShow',
        params: {
          resourceId: id
        }
      })
    },

    clickOnEditBtn (row) {
      this.$router.push({
        name: 'ResourceEdit',
        params: {
          resourceId: row.item.id
        }
      })
    },

    clickOnDeleteBtn (row) {
      this.selectedItem = row.item
      this.$bvModal.show('item-delete-modal')
    },

    didDeleteItem () {
      this.selectedItem = null
      this.$refs.B122TableResource.refreshTable()
    }

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/resource/ResourceIndex.vue